import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=395e8706&"
import script from "./Master.vue?vue&type=script&lang=ts&"
export * from "./Master.vue?vue&type=script&lang=ts&"
import style0 from "./Master.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports